import { saveAs } from 'file-saver'
/* @ngInject */
function RepositoryService ($translate, $rootScope, $location, $stateParams, ConnectorWebService, AssetService, CONSTANTS, Utils, CustomerCompanyService, SegmentService) {
  const imageExtensions = ['png', 'jpeg', 'jpg', 'gif', 'webp', 'tif', 'tiff', 'bmp', 'ext']
  const audioExtensions = ['mp3', 'wav', 'wma', 'aac', 'ac3']
  const designExtensions = ['ai', 'psd', 'svg', 'epd', 'crd', 'ext']
  const videoExtensions = ['avi', 'ktime', 'mpeg', 'x-m4v', 'mp4', 'mov', 'mkv', 'rmvb']
  const documentExtensions = ['deskfy']

  let view = ''

  const service = {
    getRecentsAssets,
    getAllAssets,
    getUsedInAssets,
    archiveAsset,
    restoreAsset,
    getTrashAssets,
    getAssetUsageById,
    defineAssetIconBasedOnExtension,
    defineAssetTypeBasedOnExtension,
    defineFullAssetNameToDisplay,
    getAllAssetTags,
    createTag,
    getHeader,
    restoreAssetsBatch,
    archiveAssetsBatch,
    setView,
    getView,
    addFolder,
    getFolders,
    moveAsset,
    moveMultipleAssets,
    updateFolder,
    archiveFolder,
    archiveFoldersBatch,
    restoreFolder,
    restoreFoldersBatch,
    searchOrganized,
    moveMultipleFolders,
    hasOrganizedAccess,
    getFolderAssets,
    getFolderById,
    getFolderPath,
    moveFolder,
    moveFoldersBatch,
    downloadAssetsFolderBatch,
    getUrlForAssetFolderId,
    copyAssetsFolderUrlsToClipboard,
    createCopyLinksBatchLog,
    getFolderDetailsById,
    getFolderSegmentation,
    shareAssetPackWithGuests,
    getSharedAssetPacks,
    getSharedAssetPacksSummaryCount,
    updateAssetPackAccessExpirationDate,
    deleteAssetPack,
    getSharedGuests,
    deleteSharedGuest,
    isSingleAttach,
    createNewDocument,
    downloadDeskfyDocument
  }
  return service

  function downloadDeskfyDocument (assetId, assetName, format = 'docx') {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_DOCS_ID_DOWNLOAD, [assetId])
    url = Utils.fnAddQueryToUrl(url, { format })

    return ConnectorWebService
      .createCustomXHR(encodeURI(url), 'GET', null, { responseType: 'arraybuffer' }, {}, { returnContext: true })
      .then((ctx) => {
        const contentType = ctx.getResponseHeader('Content-Type') || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        const blob = new Blob([ctx.response], { type: contentType })
        saveAs(blob, `${assetName}.${format}`)
      })
  }

  function createNewDocument (input = {}) {
    const { folderId, slug } = input
    const url = CONSTANTS.URL_DOCS
    const reqBody = {}
    if (slug) {
      reqBody.template = slug
    }
    if (folderId) {
      reqBody.folderId = folderId
    }

    return ConnectorWebService.post(url, reqBody)
  }

  function getRecentsAssets (queryParams) {
    const { section, $top, $skip, search, filters = {} } = queryParams

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_RECENTS, [section])

    if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (filters?.excludeExtensions) url = Utils.fnAddQueryToUrl(url, { excludeExtensions: filters.excludeExtensions })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })
    if (filters?.tags) url = Utils.fnAddQueryToUrl(url, { tags: filters.tags })
    if (filters?.modules) url = Utils.fnAddQueryToUrl(url, { modules: filters.modules })
    if (filters?.assetId) url = Utils.fnAddQueryToUrl(url, { assetId: filters.assetId })
    if (filters?.createdBy) url = Utils.fnAddQueryToUrl(url, { createdBy: filters.createdBy })
    if (filters?.designers) url = Utils.fnAddQueryToUrl(url, { designers: filters.designers })
    if (filters?.createdAt) url = Utils.fnAddQueryToUrl(url, { createdAt: filters.createdAt })
    if (filters?.updatedAt) url = Utils.fnAddQueryToUrl(url, { updatedAt: filters.updatedAt })
    if (filters?.customFields) url = Utils.fnAddQueryToUrl(url, { customFields: JSON.stringify(filters.customFields) })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function getAllAssets (queryParams, folderId = null) {
    const { $top, $skip, $sort, $order, search, organized, hasFilters, filters = {} } = queryParams
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_ALL)

    if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
    if ($sort) url = Utils.fnAddQueryToUrl(url, { $sort })
    if ($order) url = Utils.fnAddQueryToUrl(url, { $order })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (organized) url = Utils.fnAddQueryToUrl(url, { organized })
    if (folderId) url = Utils.fnAddQueryToUrl(url, { folderId: folderId })
    if (hasFilters) url = Utils.fnAddQueryToUrl(url, { hasFilters })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })
    if (filters?.tags) url = Utils.fnAddQueryToUrl(url, { tags: filters.tags })
    if (filters?.modules) url = Utils.fnAddQueryToUrl(url, { modules: filters.modules })
    if (filters?.assetId) url = Utils.fnAddQueryToUrl(url, { assetId: filters.assetId })
    if (filters?.createdBy) url = Utils.fnAddQueryToUrl(url, { createdBy: filters.createdBy })
    if (filters?.designers) url = Utils.fnAddQueryToUrl(url, { designers: filters.designers })
    if (filters?.createdAt) url = Utils.fnAddQueryToUrl(url, { createdAt: filters.createdAt })
    if (filters?.customFields) url = Utils.fnAddQueryToUrl(url, { customFields: JSON.stringify(filters.customFields) })
    if (filters?.excludeExtensions) url = Utils.fnAddQueryToUrl(url, { excludeExtensions: filters.excludeExtensions })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function getUsedInAssets (queryParams) {
    const { $top, $skip, $sort, $order, usedIn, search, filters = {} } = queryParams

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_MODULE, [usedIn])

    if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
    if ($sort) url = Utils.fnAddQueryToUrl(url, { $sort })
    if ($order) url = Utils.fnAddQueryToUrl(url, { $order })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function moveMultipleFolders (params) {
    const { folderIds, targetFolderId } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDERS_MOVE_BATCH)
    return ConnectorWebService.put(url, { folderIds, targetFolderId })
  }

  function moveAsset (asset, targetFolderId) {
    const assetId = asset.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_ASSETS_ID_MOVE, [assetId])
    return ConnectorWebService.put(url, { folderId: targetFolderId })
  }

  function moveMultipleAssets (params) {
    const { assetsId, folderId } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_ASSETS_MOVE_ASSETS)
    return ConnectorWebService.put(url, { assetsId, folderId })
  }

  function archiveAsset (asset) {
    const assetId = asset.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_ASSETS_ID_ARCHIVE, [assetId])
    return ConnectorWebService.put(url)
  }

  function archiveAssetsBatch (assets) {
    const assetsIds = assets.map(asset => asset.id)
    return ConnectorWebService.put(CONSTANTS.URL_REPOSITORIES_ARCHIVE_BATCH, { assetsIds })
  }

  function restoreAsset (asset, targetFolderId) {
    const assetId = asset.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_TRASH_RESTORE_ASSETID, [assetId])
    return ConnectorWebService.put(url, { targetFolderId })
  }

  function restoreAssetsBatch (assets, targetFolderId) {
    const assetsIds = assets.map(asset => asset.id)

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_TRASH_RESTORE_BATCH)
    return ConnectorWebService.put(url, { assetsIds, targetFolderId })
  }

  function getTrashAssets (queryParams) {
    const { $top, $skip, $sort, $order, search, filters = {}, folderId = null } = queryParams

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_TRASH)

    if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
    if ($sort) url = Utils.fnAddQueryToUrl(url, { $sort })
    if ($order) url = Utils.fnAddQueryToUrl(url, { $order })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })
    if (folderId) url = Utils.fnAddQueryToUrl(url, { folderId })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function getAssetUsageById (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_ASSETS_ID_USAGE, [assetId])

    return ConnectorWebService.get(url)
  }

  function getFolderSegmentation (folderId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_SEGMENTATION, [folderId])

    return ConnectorWebService.get(url)
  }

  function defineAssetIconBasedOnExtension (asset) {
    const extension = asset?.extension

    if (documentExtensions.includes(extension)) {
      return 'deskfy-file'
    }

    if (videoExtensions.includes(extension)) {
      return 'play'
    }

    if (audioExtensions.includes(extension)) {
      return 'headphones'
    }

    if (imageExtensions.includes(extension)) {
      return 'image'
    }

    if (designExtensions.includes(extension)) {
      return 'pen-tool'
    }

    return 'file-text'
  }

  function defineAssetTypeBasedOnExtension (asset) {
    const extension = asset?.extension

    if (videoExtensions.includes(extension)) {
      return $translate.instant('video')
    }

    if (audioExtensions.includes(extension)) {
      return $translate.instant('audio')
    }

    if (imageExtensions.includes(extension)) {
      return $translate.instant('image')
    }

    if (designExtensions.includes(extension)) {
      return $translate.instant('design')
    }

    return $translate.instant('file')
  }

  function defineFullAssetNameToDisplay (asset, displayLength) {
    const assetTruncatedName = Utils.truncateText(asset.name || asset.files[0].name, displayLength)
    const assetName = `${assetTruncatedName}.${asset.extension}`

    return assetName
  }

  function getAllAssetTags (pagination, search) {
    let url = CONSTANTS.URL_ASSET_TAGS

    if (pagination.top) {
      url = Utils.fnAddQueryToUrl(url, { $top: pagination.top })
    }

    if (pagination.skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip: pagination.skip })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { name: search })
    }

    return ConnectorWebService.get(url)
  }

  function createTag (data = {}) {
    if (!data?.name) {
      throw new Error('data.name cannot be null')
    }

    return ConnectorWebService.post(CONSTANTS.URL_ASSET_TAGS, { name: data.name })
  }

  function getHeader (searching, title, actions) {
    const {
      advancedFilters,
      searchAssets,
      clearSearch,
      onSearchAssetClick,
      hasAdvancedSearch,
      hasFilters,
      onFilter
    } = actions

    const headerToolbar = {
      search: {
        hasAdvancedSearch,
        hasFilters,
        onSearch: searchAssets,
        onSearchAssetClick,
        filters: advancedFilters,
        onFilter
      },
      repositoryFilter: {
        params: {
          all: true,
          image: false,
          video: false,
          audio: false,
          document: false,
          design: false
        }
      }
    }

    let headerNavigation = {}
    let headerTitle = ''

    if (searching) {
      headerNavigation = {
        backButton: {
          onClick: clearSearch
        }
      }
      headerTitle = $translate.instant('result')
    } else {
      headerTitle = title
    }

    return { headerToolbar, headerNavigation, headerTitle }
  }

  function setView (newView) {
    $location.search({ view: newView, previewId: $stateParams.previewId, folderPreviewId: $stateParams.folderPreviewId })
    view = newView
  }

  function getView () {
    return view
  }

  function addFolder (title, parentId = null) {
    const payload = {
      title
    }

    if (parentId) {
      payload.parentId = parentId
    }

    return ConnectorWebService.post(CONSTANTS.URL_REPOSITORIES_FOLDER, payload)
  }

  function getFolders (parentId, isArchived = false, checkContent = false) {
    let url = CONSTANTS.URL_REPOSITORIES_FOLDERS

    if (isArchived) {
      url = Utils.fnAddQueryToUrl(url, { isArchived })
    }

    if (parentId) {
      url = Utils.fnAddQueryToUrl(url, { parentId })
    }

    if (checkContent) {
      url = Utils.fnAddQueryToUrl(url, { checkContent })
    }

    return ConnectorWebService.get(url)
  }

  function updateFolder (folderId, folderName, usersId) {
    if (!folderName) {
      throw new Error('folderName cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID, [folderId])
    return ConnectorWebService.put(url, { title: folderName, usersId })
  }

  function archiveFolder (folder) {
    const folderId = folder.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID_ARCHIVE, [folderId])
    return ConnectorWebService.put(url)
  }

  function archiveFoldersBatch (folders) {
    const folderIds = folders.map(folder => folder.id)
    return ConnectorWebService.put(CONSTANTS.URL_REPOSITORIES_FOLDERS_ARCHIVE_BATCH, { folderIds })
  }

  function restoreFolder (folder, targetFolderId) {
    const folderId = folder.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID_RESTORE, [folderId])
    return ConnectorWebService.put(url, { targetFolderId })
  }

  function restoreFoldersBatch (folders, targetFolderId) {
    const folderIds = folders.map(folder => folder.id)
    return ConnectorWebService.put(CONSTANTS.URL_REPOSITORIES_FOLDERS_RESTORE_BATCH, { folderIds, targetFolderId })
  }

  function searchOrganized (queryParams = {}) {
    const { $top, $skip, $sort, $order, search, folderId, filters = {} } = queryParams
    let url = CONSTANTS.URL_REPOSITORIES_ASSETS_ORGANIZED_SEARCH

    if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
    if ($sort) url = Utils.fnAddQueryToUrl(url, { $sort })
    if ($order) url = Utils.fnAddQueryToUrl(url, { $order })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (folderId) url = Utils.fnAddQueryToUrl(url, { folderId })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })
    if (filters?.tags) url = Utils.fnAddQueryToUrl(url, { tags: filters.tags })
    if (filters?.modules) url = Utils.fnAddQueryToUrl(url, { modules: filters.modules })
    if (filters?.assetId) url = Utils.fnAddQueryToUrl(url, { assetId: filters.assetId })
    if (filters?.createdBy) url = Utils.fnAddQueryToUrl(url, { createdBy: filters.createdBy })
    if (filters?.designers) url = Utils.fnAddQueryToUrl(url, { designers: filters.designers })
    if (filters?.createdAt) url = Utils.fnAddQueryToUrl(url, { createdAt: filters.createdAt })
    if (filters?.updatedAt) url = Utils.fnAddQueryToUrl(url, { updatedAt: filters.updatedAt })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          if (row.cardType === 'folder') {
            row.title = row.name
            row.thumbnailId = row.assetId

            return row
          }
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function hasOrganizedAccess () {
    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      return !!features[String('REPOSITORIES.ORGANIZED')]
    })
  }

  function getFolderAssets (queryParams = {}, folderId) {
    const { search, filters = {} } = queryParams
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID_ASSETS, [folderId])

    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if (filters?.type) url = Utils.fnAddQueryToUrl(url, { fileType: filters.type })
    if (filters?.extension) url = Utils.fnAddQueryToUrl(url, { fileExtension: filters.extension })
    if (filters?.tags) url = Utils.fnAddQueryToUrl(url, { tags: filters.tags })
    if (filters?.assetId) url = Utils.fnAddQueryToUrl(url, { assetId: filters.assetId })
    if (filters?.designers) url = Utils.fnAddQueryToUrl(url, { designers: filters.designers })
    if (filters?.createdAt) url = Utils.fnAddQueryToUrl(url, { createdAt: filters.createdAt })
    if (filters?.updatedAt) url = Utils.fnAddQueryToUrl(url, { updatedAt: filters.updatedAt })

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function getFolderById (folderId, isArchived = false) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID, [folderId])
    url = Utils.fnAddQueryToUrl(url, { isArchived })

    return ConnectorWebService.get(url)
  }

  function getFolderPath (folderId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID_PATH, [folderId])
    return ConnectorWebService.get(url)
  }

  function moveFolder (folder, targetFolderId) {
    const folderId = folder.id

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_ID_MOVE, [folderId])
    return ConnectorWebService.put(url, { targetFolderId })
  }

  function moveFoldersBatch (folders, targetFolderId) {
    const folderIds = folders.map(folder => folder.id)
    return ConnectorWebService.put(CONSTANTS.URL_REPOSITORIES_FOLDERS_MOVE_BATCH, { folderIds, targetFolderId })
  }

  function downloadAssetsFolderBatch (folderIds, downloadModule) {
    let url = Utils.addQueryStringFromArray(CONSTANTS.URL_REPOSITORIES_FOLDER_DOWNLOAD_BATCH, 'folderIds', folderIds)

    if (downloadModule) {
      url = Utils.fnAddQueryToUrl(url, { downloadModule })
    }

    return Utils.downloadFile(url)
  }

  function getUrlForAssetFolderId (folderId) {
    const currentLocation = $location.path()
    const companyBaseUrl = CustomerCompanyService.getCompanyBaseUrl()

    if (currentLocation.includes('/repository/organized/folders/')) {
      /* eslint-disable-next-line */
      const updatedLocation = currentLocation.replace(/\/folders\/[^\/]+$/, `/folders/${folderId}`)
      return `${companyBaseUrl}${updatedLocation}`
    } else {
      return `${companyBaseUrl}${currentLocation}/folders/${folderId}`
    }
  }

  function copyAssetsFolderUrlsToClipboard (folders) {
    const foldersIds = folders.map(folder => folder.id)
    const foldersUrls = []

    foldersIds.forEach(folderId => {
      foldersUrls.push(getUrlForAssetFolderId(folderId))
    })

    createCopyLinksBatchLog(foldersIds)
    SegmentService.track('file-share-link-copy', { object_type: 'folder' })

    return navigator.clipboard.writeText(foldersUrls.join(', '))
  }

  function createCopyLinksBatchLog (foldersIds) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_COPY_LINK_BATCH)

    return ConnectorWebService.post(url, { foldersIds })
  }

  function getFolderDetailsById (folderId, limit, offset) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_REPOSITORIES_FOLDER_HISTORY, [folderId])

    if (limit) {
      url = Utils.fnAddQueryToUrl(url, { $top: limit })
    }

    if (offset) {
      url = Utils.fnAddQueryToUrl(url, { $skip: offset })
    }

    return ConnectorWebService.get(url)
  }

  function shareAssetPackWithGuests (data) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK)
    return ConnectorWebService.post(url, data)
  }

  function getSharedAssetPacks (params) {
    let url = CONSTANTS.URL_SHARE_ASSET_PACK

    if (params) {
      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  function getSharedAssetPacksSummaryCount () {
    return ConnectorWebService.get(CONSTANTS.URL_SHARE_ASSET_PACK_SUMMARY_COUNT)
  }

  function updateAssetPackAccessExpirationDate (assetPackId, data) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_UPDATE_ACCESS_EXPIRATION_DATE, [assetPackId])

    return ConnectorWebService.put(url, data)
  }

  function deleteAssetPack (assetPackId) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_DELETE, [assetPackId]))
  }

  function getSharedGuests (assetPackId, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_GET_ACCESS_LIST, [assetPackId])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function deleteSharedGuest (assetPackId, guestId) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_DELETE_GUEST_ACCESS, [assetPackId, guestId]))
  }

  function isSingleAttach (singleAttach, selectedAssets, asset) {
    const hasOtherAssetsSelected = selectedAssets?.some(selectedAsset => selectedAsset.id !== asset.id)
    const isSingleAttach = singleAttach && hasOtherAssetsSelected && selectedAssets?.length

    return isSingleAttach
  }
}

export { RepositoryService }
